import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        dialogRoot: css`
            ${custom.boxShadowRadius};
        `,
        dialogContentRoot: css`
            ${common.flexJustityAlignCenter};
            padding: 0 30px;
        `,
        dialogActionsRoot: css`
            ${common.dialogActionsRoot};
            padding-bottom: 40px;
        `,
        button: css`
            margin: 0 40px;
            padding: 0;
            ${custom.button};
        `,
        icon: css`
            width: 70px;
            height: 80px;
            padding-right: 10px;
        `,
    }
}

export default styles
